/**
 * @fileoverview What the plants brief says about the garden, as the sort and the filters read it
 * (PlantAttention): the "Needs you first" places, each plant's marks for the verdict filter, and the plants that
 * can be planted now (B84). Pure; the server decided all of it.
 *
 * Where: PlantGrid.
 * API: none; the brief comes from GET /plants/brief.
 * Settings: none.
 * Words (en/es): none.
 *
 * @module attentionFrom
 */

import type { PlantsBrief } from '@/shared/api/plantsBrief';
import type { PlantAttention } from './plantViews';
import { plantNowIds } from './canPlantNowFilter';

/**
 * The brief's order as places, its marks by plant and its plants that can be planted now.
 *
 * @param brief - The plants brief, or null while it is not in.
 * @returns What arrangePlants reads; null until the brief is in. The marks are null without an outlook, so the
 *   verdict filter never manufactures a confident empty garden from a forecast it never saw.
 */
export function attentionFrom(brief: PlantsBrief | null | undefined): PlantAttention | null {
  if (!brief) return null;
  const verdicts = new Map<number, Set<string>>();
  for (const [id, entry] of Object.entries(brief.plants)) {
    if (entry.week && entry.week.marks.length > 0) verdicts.set(Number(id), new Set(entry.week.marks.map((mark) => mark.family)));
  }
  return {
    place: new Map(brief.order.map((id, index) => [id, index])),
    verdicts: brief.hasOutlook ? verdicts : null,
    plantNow: plantNowIds(brief.plants),
  };
}
